import i18next, { init } from 'i18next';
// import { initReacti18n } from 'react-i18next';
import ptBrTranslations from "./locale/pt-br.json"
import enTranslations from "./locale/en.json"
import { initReactI18next } from 'react-i18next';


i18next
.use(initReactI18next)
.init({
    resources: {
        en: {
            //criar
            ...enTranslations
        
        },
        ptBr: {
            ...ptBrTranslations
        }
    },
    lng: 'en',
    interpolation: {
        escapeValue: false
    }
})

const handleChangeLanguage = () => {
    const newLanguage = i18next.resolvedLanguage === 'en' ? 'ptBr' : 'en';
    i18next.changeLanguage(newLanguage);
  };

  const allLanguages = [
    { value: "en", label: i18next.t("language_options_en") },
    { value: "ptBr", label: i18next.t("language_options_ptBr") }
  ]

export { handleChangeLanguage, allLanguages };
export default i18next